/* Service Worker registration with update notification.
 * Skipped in dev (CRA default) so it doesn't interfere with hot reload.
 */
export function registerServiceWorker({ onUpdateAvailable } = {}) {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Avoid registering on localhost dev (CRA dev server has its own behaviour).
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  if (isLocalhost && process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        // Detect updates: a new SW has been installed and is waiting.
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // New version available
              if (typeof onUpdateAvailable === "function") {
                onUpdateAvailable(registration);
              }
            }
          });
        });
      })
      .catch(() => {
        // Silent failure: PWA is a progressive enhancement.
      });
  });

  // Reload page when the new SW takes control (after user accepts update).
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

export function triggerSWUpdate(registration) {
  if (registration && registration.waiting) {
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
  }
}
